import EventBus from '../event-bus';

export default {
    data:() => ({
        server_api:'http://187.157.97.110:3003',
        // server_api:'http://eventos.difoaxaca.gob.mx',
        //server_api:'http://localhost:3003',
        //server_api:'http://192.168.0.151:3003',
        saveUsuario:{
            nombre: '',
            rol: '',
            municipio: null,
            municipio_nombre: null,
            localidad: null,
            localidad_nombre: null,
            region:null,
            distrito:null
        },
        logueado: false
    }),
    created() {
        EventBus.$on('change:SignIn',(usuario)=>{
            this.SignIn(usuario);
        });

        EventBus.$on('change:SingOut',()=>{
            this.SingOut();
        });

        if(localStorage.usuario && localStorage.token){
            let usuario =  JSON.parse(localStorage.usuario);
            this.SignIn(usuario);
        }
    },
    methods:{
        SignIn(usuario){
            this.saveUsuario.nombre = usuario;
            this.logueado = true;
        },
        SingOut(){
            this.saveUsuario.nombre = '';
            this.saveUsuario.rol = '';
            this.saveUsuario.municipio = null;
            this.saveUsuario.municipio_nombre = null;
            this.saveUsuario.localidad = null;
            this.saveUsuario.localidad_nombre = null;
            this.saveUsuario.distrito = null;
            this.saveUsuario.region = null;
            this.logueado = false;
            localStorage.removeItem('usuario');
            localStorage.removeItem('token');
        }
    }
}